import { createSelector } from "reselect";

export const getRecord = state => state.record;
export const getRecordId = createSelector(getRecord, record => record && record.id);
export const getRecordDraft = state => state.draft;
export const getRecordIsEditing = createSelector(getRecordDraft, draft => !!draft);